import { Sparkles } from 'lucide-react';
import { cn } from '@/lib/utils';
import { appSidebarNavLinkClassName } from '@/lib/sidebarNav';
import { useAiAssistantPanelOptional } from '../context/aiAssistantPanelContext';

/**
 * Sidebar entry for the assistant.
 *
 * A button rather than a NavLink because the assistant is a slide-over panel,
 * not a route — navigating away would lose whatever page the user wanted to ask
 * about. It borrows `appSidebarNavLinkClassName` so it sits flush with the real
 * nav links, and is never "active" since there is no matching route.
 */
export function AiAssistantNavItem({ expanded = true, onActivate }) {
    const panel = useAiAssistantPanelOptional();
    if (!panel) return null;

    return (
        <button
            type="button"
            title="Ask Mela"
            onClick={() => {
                panel.openPanel();
                onActivate?.();
            }}
            className={cn(
                appSidebarNavLinkClassName({ isActive: false, expanded }),
                'w-full text-left',
            )}
        >
            <Sparkles className="h-5 w-5 flex-shrink-0" aria-hidden />
            <span className={cn('leading-tight', !expanded && 'sr-only')}>Ask Mela</span>
        </button>
    );
}

export default AiAssistantNavItem;
